<template>
    <div class="setting-card">
        <div class="setting-header">
            <a-icon :type="icon" class="setting-icon" />
            <h5 class="setting-title">{{ title }}</h5>
        </div>
        <div class="setting-content">
            <slot>
                <div class="setting-value-wrapper">
                    <div class="setting-value">{{ value }}</div>
                    <div v-if="subValue" class="setting-sub-value">{{ subValue }}</div>
                </div>
            </slot>
            <a-button 
                v-if="!$slots.default && value"
                type="primary" 
                shape="circle" 
                icon="edit"
                size="small"
                class="edit-button"
                @click="$emit('edit')"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingCard',
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            default: null
        },
        subValue: {
            type: [String, Number],
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
.setting-card {
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;

    &:hover {
        background: #f5f5f5;
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .setting-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .setting-icon {
            font-size: 18px;
            color: #1890ff;
        }

        .setting-title {
            margin: 0;
            font-size: 13px;
            font-weight: 600;
            color: #595959;
        }
    }

    .setting-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        .setting-value-wrapper {
            flex: 1;

            .setting-value {
                font-size: 20px;
                font-weight: 700;
                color: #262626;
            }

            .setting-sub-value {
                font-size: 12px;
                color: #8c8c8c;
                margin-top: 4px;
            }
        }

        .edit-button {
            flex-shrink: 0;
        }
    }

    &.payment-method-card {
        .setting-content {
            display: block;
        }
    }
}
</style>
